import { useCallback } from "react"
import { useController, useFormContext } from "react-hook-form"
import type { CheckboxGroupItem } from "./CheckboxGroup"
import { CheckboxGroup } from "./CheckboxGroup"

export interface CheckboxGroupFieldProps {
	disabledHint?: string
	inline?: boolean
	items: CheckboxGroupItem[]
	label?: string
	name: string
	onChange?: (value: string[], changedValue: string, type: "select" | "deselect") => void
	/** Enable and disable input unregister after unmount. @default true */
	shouldUnregister?: false
}

export const CheckboxGroupField = (props: CheckboxGroupFieldProps) => {
	const { disabledHint, inline, items, label, name, onChange, shouldUnregister, ...rest } = props

	const { control } = useFormContext()
	const {
		field: { onChange: fieldOnChange, value },
		fieldState: { error },
	} = useController({
		control,
		name,
		shouldUnregister: shouldUnregister !== false,
	})

	const handleChange = useCallback(
		(newValue: string[], changedValue: string, type: "select" | "deselect") => {
			fieldOnChange(newValue)
			onChange?.(newValue, changedValue, type)
		},
		[fieldOnChange, onChange],
	)

	return (
		<CheckboxGroup
			{...rest}
			items={items}
			error={error?.message}
			onChange={handleChange}
			value={value}
			label={label}
			inline={inline}
			disabledHint={disabledHint}
		/>
	)
}
